import { downloadBlobAsFile, generateXLSX, getCsvData, XLSXRow } from '@retail/products/utils';
import dayjs from 'dayjs';
import { ConditionsNew } from '@retail/calculus/types';
import { useAppTFunction } from '@retail/app/i18n';

const uploadMarkupCsvData =
  '\uFEFFMgItem-nummer;Varugrupp;Rabattgrupp;GyldigFra;GTIN;Salgsfaktor;Salgspris;InkMva';

const columnOrder = [
  'mgItemNumber',
  'groupNumber',
  'discountGroupCode',
  'validFrom',
  'gtinCode',
  'salesFactor',
  'salesPrice',
];

export const useMarkupExport = () => {
  const t = useAppTFunction();
  const data: XLSXRow[] = [[...uploadMarkupCsvData.split(';')]];

  const getMarkupAsRows = (markupConditions: ConditionsNew[]) => {
    const markupRows: XLSXRow[] = [];

    markupConditions.forEach((markup) => {
      const row: Record<string, string | number | null> = {
        mgItemNumber: markup.bindingType === 'MG_SUPPLIER_ITEM' ? markup.bindingTargetId : null,
        groupNumber:
          markup.bindingType === 'OVERGRUPPE' ||
          markup.bindingType === 'HOVEDGRUPPE' ||
          markup.bindingType === 'VAREGRUPPE'
            ? markup.bindingTargetId
            : null,
        discountGroupCode: markup.bindingType === 'DISCOUNT_GROUP' ? markup.bindingTargetId : null,
        validFrom: markup.markupCondition?.validFrom
          ? dayjs(markup.markupCondition?.validFrom).format('YYYY-MM-DD')
          : null,
        gtinCode:
          markup.bindingTargetItem?.packageType !== 'PRIMARY'
            ? markup.bindingTargetItem?.gtinCode ?? null
            : null,
        salesFactor: markup.markupCondition?.salesFactor ?? null,
        incMva: null,
      };

      const rowValues = columnOrder.map((key) => row[key]);
      markupRows.push(rowValues);
    });

    return markupRows;
  };

  const exportAsCsv = (markupConditions: ConditionsNew[]) => {
    const updatedData = [...data, ...getMarkupAsRows(markupConditions)];
    const csvData = getCsvData(updatedData);

    const blob = new Blob([csvData], {
      type: 'text/csv',
    });

    downloadBlobAsFile(blob, `${t('markup.markup')}-${dayjs().format('YYYY-MM-DD')}.csv`);
  };

  const exportAsXLSX = async (markupConditions: ConditionsNew[]) => {
    const updatedData = [...data, ...getMarkupAsRows(markupConditions)];

    try {
      generateXLSX({
        rows: updatedData,
        fileName: `${t('markup.markup')}-${dayjs().format('YYYY-MM-DD')}`,
      });
    } catch (error) {
      console.error('Error exporting XLSX:', error);
    }
  };

  return {
    exportAsCsv,
    exportAsXLSX,
  };
};
